module.exports = __webpack_public_path__ + "static/media/revyn.f40dd25a.png";